var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNotesEmpty = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 64,
    viewBox: "0 0 96 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50:897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.0811 44.1755C78.0481 55.3993 65.9298 59.4545 57.6345 61.0594C47.3555 63.0496 31.883 62.0117 21.7724 56.694C12.9841 52.0718 5.65063 44.4751 2.16421 34.2891C-0.612915 26.1788 -0.504715 19.7055 1.28659 13.2002C3.08991 6.6948 10.171 -1.52248 22.5177 0.242949C34.8645 2.00838 38.3148 10.001 41.7532 15.3936C46.6823 23.1401 51.9841 24.7236 61.6018 23.4932C71.2315 22.252 78.3607 22.4981 83.3859 25.815C87.3893 28.4364 90.5391 35.4767 85.0811 44.1755Z",
    fill: "#E1E9F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9769 32.5093C28.9395 32.5064 28.9021 32.5035 28.8618 32.4891C26.292 31.8453 23.9673 30.5656 22.1466 28.8057C16.6387 23.4883 17.3727 15.6859 17.5839 14.1778C17.6504 13.7087 18.0594 13.3866 18.517 13.456C18.9717 13.5139 19.2851 13.9373 19.2186 14.4064C19.0333 15.7734 18.369 22.8247 23.2845 27.5804C24.9095 29.1445 26.9782 30.28 29.2746 30.8574C29.7178 30.9671 29.9793 31.4278 29.8725 31.8825C29.7657 32.2882 29.3798 32.5556 28.9769 32.5093Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2957 12.5909C16.2957 12.5909 14.7257 14.4865 16.6366 14.842C18.5446 15.1859 17.8658 10.6953 16.2957 12.5909Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2163 11.2239C19.2163 11.2239 17.495 14.017 19.4186 14.3245C21.334 14.6133 20.9376 8.43077 19.2163 11.2239Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6928 12.01C17.6928 12.01 15.8793 13.6684 17.7258 14.2864C19.5612 14.9002 19.5063 10.3515 17.6928 12.01Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3942 14.7147C17.5884 13.9409 18.0986 13.4407 18.8379 13.3106C19.7188 13.1617 20.9315 13.5184 20.6616 14.5396C20.4895 15.1749 20.1785 15.4081 19.8348 15.425C19.164 15.4574 18.3942 14.7147 18.3942 14.7147Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 51,
    r: 2,
    fill: "#193E6D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 60,
    r: 4,
    fill: "#193E6D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 2.5,
    r: 2.5,
    fill: "#193E6D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.5,
    cy: 11.5,
    r: 7.5,
    fill: "#E1E9F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6462 50.9396L66.9162 39.6696C67.6156 38.9702 68 38.0344 68 37.0633V15.6667C68 13.6523 66.3477 12 64.3333 12H31.6667C29.6523 12 28 13.6523 28 15.6667V48.3333C28 50.3477 29.6523 52 31.6667 52H53.0633C54.0382 52 54.9728 51.613 55.6462 50.9396Z",
    fill: "white",
    stroke: "#00838F",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1422 32.5359C55.6714 30.9723 56.5573 29.3232 58.1208 28.8524C59.6844 28.3816 61.3335 29.2675 61.8043 30.8311C62.2751 32.3946 61.3892 34.0438 59.8257 34.5145C58.2621 34.9853 56.613 34.0994 56.1422 32.5359Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8431 30.9539C58.9495 31.5069 59.46 31.8685 60.013 31.7622C60.5661 31.6558 60.9277 31.1453 60.8213 30.5922C60.715 30.0392 60.2045 29.6776 59.6514 29.7839C59.1196 29.8903 58.7367 30.4221 58.8431 30.9539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8535 34.482C34.2775 34.054 33.3469 32.4295 33.7749 30.8535C34.2029 29.2776 35.8274 28.347 37.4034 28.775C38.9793 29.203 39.9099 30.8275 39.4819 32.4035C39.054 33.9794 37.4294 34.91 35.8535 34.482Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5043 30.9248C36.6106 31.4778 37.1211 31.8395 37.6742 31.7331C38.2272 31.6267 38.5889 31.1162 38.4825 30.5632C38.3761 30.0101 37.8656 29.6485 37.3126 29.7549C36.7808 29.84 36.4192 30.3717 36.5043 30.9248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4111 38.7554C46.8522 38.9116 47.3547 39.0219 47.9187 39.0862C50.9744 39.3785 52.6427 37.2163 53.0888 36.0203C53.2166 35.6594 53.0353 35.2793 52.7015 35.1385C52.7015 35.1385 52.7015 35.1385 52.6815 35.1314C52.3406 35.0107 51.9605 35.192 51.8197 35.5258C51.7842 35.626 50.8319 37.9967 48.0381 37.7294C44.5931 37.3895 44.4263 34.4194 44.4088 34.2778C44.382 33.9073 44.0779 33.6191 43.7145 33.6258C43.344 33.6525 43.0557 33.9566 43.0624 34.3201C43.126 35.6062 43.9047 37.8678 46.4111 38.7554Z",
    fill: "#363437"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50:897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 64,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNotesEmpty, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/notes-empty.58d13567.svg";
export { ForwardRef as ReactComponent };